import React from 'react';
import {Card, Avatar, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  Horizontalcontainer:{
    display:'flex',
    flexDirection:'row',
    padding:'30px 20px',
    justifyContent:'center',
    alignItems:'center'
  },
  CardStyle:{
    maxWidth:'220px',
    borderRadius:'20px',
    margin:'10px'
  },
  AvatarStyle:{
    width:theme.spacing(6),
    height:theme.spacing(6),
  },
  title:{
    paddingLeft:'20px',
    color:'#153BAB',
    fontFamily:['Nunito'].join(','),
  },

  info:{
    fontFamily:['Nunito'].join(','),
    fontSize:'12px',
    paddingLeft:'20px',
    paddingRight:'20px',
    paddingTop:'10px',
    lineHeight:'17px',
    paddingBottom:'50px',
  }

}));

const CompanyCard = (props) =>{
  const classes = useStyles();
  return (

    <Card className={classes.CardStyle}>
      <div className={classes.Horizontalcontainer}>
      <Avatar className={classes.AvatarStyle} src={props.picture} ></Avatar>
      <Typography variant='h6' className={classes.title}><strong>About The Company</strong></Typography>
      </div>
      <Typography className={classes.info}>{props.about}</Typography>
    </Card>

  );
}

export default CompanyCard;
